import React from 'react';
import { instanceOf, func } from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';

import DictionaryInput from './DictionaryInput';
import { updateInvalidQnO } from '../../../actions/turnkeyOmnibusActions';

const DictionaryList = ({ dictionary, invalid, updateInvalidQnO }) => {
  const _setError = (item, error) => {
    let specialChar = [...invalid.specialChar];
    let maxLength = [...invalid.maxLength];

    if (error.specialChar) {
      if (!specialChar.includes(item)) {
        specialChar.push(item);
      }
    } else {
      specialChar = specialChar.filter(k => k !== item);
    }

    if (error.maxLength) {
      if (!maxLength.includes(item)) {
        maxLength.push(item);
      }
    } else {
      maxLength = maxLength.filter(k => k !== item);
    }
    if (!isEqual(invalid.specialChar, specialChar) || !isEqual(invalid.maxLength, maxLength)) {
      updateInvalidQnO({ specialChar, maxLength });
    }
  };

  const _renderRow = (id, type, text, qText, item, index) => {
    return (
      <div
        key={`${type}_${index}_${id}`}
        id={`${type}_${index}_${id}`}
        className="ie--dictionary--row"
      >
        <div className="ie--dictionary--qno">
          {type === 'Q' ? index : <span>&nbsp;</span>}
        </div>
        <div className="ie--dictionary--q-text">
          <span title={qText}>{qText}</span>
        </div>
        <div className="ie--dictionary--d-text">
          <DictionaryInput
            text={text}
            currentObj={item}
            type={type}
            setError={error => _setError(`${type}_${index}_${id}`, error)}
          />
        </div>
      </div>
    );
  };

  const _renderRows = () => {
    const dRows = Object.keys(dictionary).map((qid, index) => {
      const question = dictionary[qid].question;
      const qOptions = dictionary[qid].options;
      const combinedRow = [];
      const qText = question.shortDescription;
      const qType = qid > 0 ? 'Q' : 'SN';
      const questionRow = _renderRow(
        qid,
        qType,
        qText,
        question.description,
        question,
        index
      );
      combinedRow.push(questionRow);

      Object.keys(qOptions.column).map((oid, oIndex) => {
        const option = qOptions.column[oid];
        const text = option.shortDescription;
        const oRow = _renderRow(
          `${qid}_${oid}`,
          'O',
          text,
          option.description,
          option,
          oIndex
        );
        combinedRow.push(oRow);
        return false;
      });

      Object.keys(qOptions.row).map((subQid, oIndex) => {
        const option = qOptions.row[subQid];
        const text = option.subQuestionShortDesc;
        const sQrow = _renderRow(
          `${qid}_${subQid}`,
          'sQ',
          text,
          option.subQuestionDesc,
          option,
          oIndex
        );
        combinedRow.push(sQrow);
        return false;
      });
      return combinedRow;
    });
    return dRows;
  };

  return (
    <div className="ie--dictionary--box">
      <div className="ie--dictionary--container">
        <div className="ie--dictionary--header">
          <div className="ie--dictionary--row">
            <div className="ie--dictionary--qno">Q#</div>
            <div className="ie--dictionary--q-text">Question Text</div>
            <div className="ie--dictionary--d-text">Dictionary Text</div>
          </div>
        </div>
        <div className="ie--dictionary--body">{_renderRows()}</div>
      </div>
    </div>
  );
};

DictionaryList.propTypes = {
  invalid: instanceOf(Object),
  dictionary: instanceOf(Object),
  updateInvalidQnO: func,
};

DictionaryList.defaultProps = {
  invalid: {
    specialChar: [],
    maxLength: [],
  },
  dictionary: null,
};

const mapStateToProps = ({ turnkeyOmnibus }) => {
  const { surveyQnO } = turnkeyOmnibus;
  return {
    invalid: surveyQnO.invalid,
    dictionary: surveyQnO.dictionary,
  };
};

export default connect(
  mapStateToProps,
  { updateInvalidQnO }
)(DictionaryList);
